import { LOAD } from '../load.config'

// How a preset splits the item F impact budget (LOAD.craterParticlesPeak
// sprites alive at the peak): the explosion flipbook, smoke and debris come
// out of it and the sparks get the rest, so the peak is the same for every
// preset and every effect toggle. The clash burst reuses spark sprites.
export function effectBudget(cfg) {
    const total = LOAD.craterParticlesPeak
    const explosion = cfg.explosion.enabled ? 1 : 0
    const smoke = cfg.smoke.enabled ? cfg.smoke.count : 0
    const debris = cfg.debris.enabled ? cfg.debris.count : 0
    const sparks = total - explosion - smoke - debris
    const burst = cfg.clash.enabled ? cfg.clash.burstParticles : 0
    if (sparks < Math.max(1, burst)) throw new Error(`reveal preset leaves ${sparks} sparks of ${total} (needs at least ${Math.max(1, burst)})`)
    return { total, explosion, smoke, debris, sparks }
}
